module.exports = __webpack_public_path__ + "static/media/runway_hero.fc394c91.jpeg";